import { tap } from "ramda";
import { EncoderTypes } from "./types";
const isSelectedDeviceChangedMessage = (message) => message.type === EncoderTypes.SELECTED_DEVICE_CHANGED;
const CUSTOM_KEYGEN = {
    [EncoderTypes.SELECTED_DEVICE_CHANGED]: (message, key) => isSelectedDeviceChangedMessage(message) ? `${key}-${message.payload.type}` : key,
};
export const keyGen = (message) => {
    const key = message.type;
    const customKey = CUSTOM_KEYGEN[key];
    return customKey ? customKey(message, key) : key;
};
export const lastMessageMiddleware = (tracker) => tap((message) => {
    tracker.lastMessageCache.set(keyGen(message), message);
});
//# sourceMappingURL=middleware.js.map